var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('create-form',{attrs:{"type":"create"},on:{"onsave":_vm.onCreate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }